export const getDocRefId = (): string => {
  let docRefId = sessionStorage.getItem("docRefId");

  if (!docRefId) {
    const bytes = crypto.getRandomValues(new Uint8Array(24));
    docRefId = btoa(String.fromCharCode(...bytes))
      .replace(/\+/g, "-")
      .replace(/\//g, "_");

    sessionStorage.setItem("docRefId", docRefId);
  }

  return docRefId;
};